const form = `
  <div class="alert alert-fillup">
    <h4 class="mt-0 mb-3 color-fillup">Wygeneruj własny numer mikrorachunku</h4>
    <form id="microaccount-form" class="microaccount-form">
    
      <div class="row">
        <div class="form-group col-md-4">
          <label for="microaccount-type">Identyfikator</label>
          <select id="microaccount-type" class="form-control" name="type">
            <option value="1">PESEL</option>
            <option value="2">NIP</option>
          </select>
        </div>
        <div class="form-group col-md-4">
          <label for="microaccount-id">Numer <span>PESEL</span></label>
          <input
            id="microaccount-id"
            class="form-control"
            name="id"
            type="text"
            maxlength="11"
            placeholder=""
            required>
        </div>
        <div class="col">
          <button type="submit" class="btn more btn-block btn-outline-go">Generuj</button>
        </div>
      </div>

    </form>
  </div>
`;

export default form;